document.addEventListener("DOMContentLoaded", () => {

    const items = document.querySelectorAll(".accordion button.btn");
    let height;

    function getAccordionContent(button) {
        // Case 1: content is next element sibling (inline accordion)
        const next = button.nextElementSibling;
        if (next && next.classList.contains("accordion-content")) {
            return next;
        }
        // Case 2: button is separated from content, linked via aria-controls
        const controlsId = button.getAttribute("aria-controls");
        if (controlsId) {
            return document.getElementById(controlsId);
        }
        return null;
    }

    function getHeight(content) {
        height = content.querySelector(".accordion-content-inner").offsetHeight;
        return height;
    }

    function toggleAccordion() {
        const content = getAccordionContent(this);
        if (!content) return;

        getHeight(content);

        const itemToggle = this.getAttribute("aria-expanded");

        for (let i = 0; i < items.length; i++) {
            items[i].setAttribute("aria-expanded", "false");
            const c = getAccordionContent(items[i]);
            if (c) {
                c.style.maxHeight = null;
                c.style.opacity = null;
                c.style.transition = null;
                c.style.willChange = null;
            }
        }

        if (itemToggle === "false") {
            this.setAttribute("aria-expanded", "true");
            content.style.maxHeight = `${height}px`;
            content.style.opacity = "1";
            content.style.transition = "all 200ms linear";
            content.style.willChange = "opacity, max-height";
            setTimeout(() => content.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
        }
    }

    items.forEach((item) => item.addEventListener("click", toggleAccordion));

});
